  // 1. Add texts to bold
  const textsToBold = [
    "200 points",
    "500 points",
    "1000 points",
    "2250 points",
    "1.25 points",
    "2%",
    "5%",
    "10%",
    "$20",
    "$30",
    "$75",
    "$10"

  ];

  // 2. Check and execute
  var checkExist = setInterval(function() {
    var elements = document.querySelectorAll('.Joy-VIPTier__Text');

    if (elements.length > 0) {
       clearInterval(checkExist);

       elements.forEach(function(el) {
          let content = el.innerHTML;

          textsToBold.forEach(function(text) {
             if (content.includes(text)) {
                content = content.split(text).join("<strong>" + text + "</strong>");
             }
          });

          el.innerHTML = content;
       });
    }
  }, 500); 